"use client";

import "@fortawesome/fontawesome-free/css/all.css";

import ErrorPage from "@soprisapps/components/pages/ErrorPage";
import { Theme } from "@soprisapps/components/components/radix/Theme";

export default function Error() {
  return (
    <html>
      <body>
        <Theme>
          <ErrorPage statusCode={500} />
        </Theme>
      </body>
    </html>
  );
}
